import { PlayerSettings } from './configs/player-settings';
import { TrackingSettings } from './configs/tracking-settings';
//import { getAmpConfig } from 'svp/configs/get-amp-config';
import { AmpVideoConfig, AmpAudioConfig } from './configs';
import { debug } from './utils/debug-log';
import getSecondsFromTimeString from './utils/get-seconds-from-time-string';
//import { default as MobileDetect } from 'mobile-detect';


//let md = new MobileDetect(window.navigator.userAgent);

//console.log("User Agent:",md.userAgent());
//console.log("OS:",md.os());
const version = `${VERSION}`; // VERSION: Defined in Webpack Config
let isUserUnmuted = false;
let lastEventState = null;

export class MediaPlayerProxy {
    constructor(containerEl, playerSettings = new PlayerSettings(), trackingSettings = new TrackingSettings()) {
        if (typeof trackingSettings.playerName !== 'undefined') {
            console.warn('Please update your video tracking configuration. playerName has been renamed to moduleName');
            trackingSettings.moduleName = trackingSettings.playerName;
        }

        //console.log("[MediaPlayerProxy] playerSettings:",playerSettings);
        if(typeof playerSettings.duration === 'string') {
            playerSettings = Object.assign({},playerSettings,{
                "duration": getSecondsFromTimeString(playerSettings.duration)
            })
            //console.log("[MediaPlayerProxy] playerSettings 2:",playerSettings);
        }

        this._amp = null;
        this._ampEventsSources = null;
        this._containerEl = containerEl;
        this._el = null;
        this._playerSettings = playerSettings;
        this._omnitureTracking = null;
        this._trackingSettings = trackingSettings;
        this._heartbeatTracking = null;
        this._subscriptions = [];
        this._ampConfig = null;

    }

    get amp() {
        return this._amp;
    }
    set amp(amp = null) {
        this._amp = amp;
    }
    get ampConfig() {
        let { amp, playerSettings } = this;
        debug.log("[MediaPlayerProxy][GET](ampConfig) playerSettings:", playerSettings);
        if (this._ampConfig == null || this._ampConfig.media.metadata.videoId != playerSettings.videoId) {

            const DefaultSettings = {
                muted: amp == null ? (this.isUserUnmuted === false) : amp.muted
            }

            debug.log("[MediaPlayerProxy][GET](ampConfig) this.amp:", this.amp, "\nDefaultSettings:", DefaultSettings);
            let settings = Object.assign({}, DefaultSettings, this.playerSettings);
            const AmpConfig = playerSettings.medium === "audio" ? AmpAudioConfig : AmpVideoConfig;
            // Check if a video has already been unmuted. 
            // If video has been unmuted, autoplay videos don't need to be muted anymore
            let config = new AmpConfig(settings);
            if (config.media.autoplay === false) {
                config.muted = false;
            }
            if(playerSettings.captioning) {
                config.captioning = playerSettings.captioning;
            } 
            //config.captioning = settings.captioning;

            debug.log("[MediaPlayerProxy] Created AmpConfig:", config);
            this._ampConfig = config;
        }
        return this._ampConfig;
    }
    get ampEventsSources() {
        if (this.amp != null) {
            return this.amp.AmpEventsSources;
        }
        return null;
    }

    get containerEl() {
        return this._containerEl;
    }
    get el() {
        if (this._el == null) {
            const { medium } = this.playerSettings;
            const className = medium === "audio" ? "medscape-audio-player" : "streaming-video-player";
            //const mediaEl = medium !== "audio" ? document.createElement("video") : document.createElement("audio");
            let el = document.createElement('div');

            el.classList.add(className);
            el.dataset["svp.version"] = this.version;
            
            //el.appendChild(mediaEl);
            const orig = el.cloneNode(true);

            this._el = el;
        }
        return this._el;
    }
    get heartbeatTracking() {
        return this._heartbeatTracking;
    }
    set heartbeatTracking(tracking = null) {
        this._heartbeatTracking = tracking;
    }

    get isUserUnmuted() {
        return isUserUnmuted;
    }
    set isUserUnmuted(flag = isUserUnmuted) {
        debug.log("[MediaPlayerProxy] Set isUserUnmuted:", flag);
        isUserUnmuted = flag;
    }

    get lastEventState() {
        return lastEventState;
    }
    set lastEventState(state = null) {
        debug.log("[MediaPlayerProxy] Set lastEventState:", state);
        lastEventState = state;
    }
    get playerSettings() {
        return this._playerSettings;
    }
    set playerSettings(settings) {
        this._playerSettings = settings;

    }
    get trackingSettings() {
        return this._trackingSettings;
    }
    get omnitureTracking() {
        return this._omnitureTracking;
    }
    set omnitureTracking(tracking) {
        this._omnitureTracking = tracking;
    }
    get subscriptions() {
        return this._subscriptions;
    }
    set subscriptions(subscriptions = []) {
        this._subscriptions = subscriptions;
    }
    get PlayerSettings() {
        return PlayerSettings;
    }
    get TtrackingSettings() {
        return TrackingSettings;
    }

    get version() {
        return version;
    }
    static get PlayerSettings() {
        return PlayerSettings;
    }
    static get TrackingSettings() {
        return TrackingSettings;
    }

    static get VERSION() {
        return version;
    }

}